<template>
  <div>
    <!--  注文製品選択画面 -->
    <t-card v-loading="loading">
      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.ReceOrderSelectDialog.colOneSpan'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                :data="cc"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                border
                fit
              >
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :width="
                    column.prop !== 'aodProdRemarksSum'
                      ? column.realWidth
                      : getRemarksColumnWidthProc()
                  "
                  :min-width="
                    column.prop !== 'aodProdRemarksSum'
                      ? column.width
                      : undefined
                  "
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="
                    column.prop === 'aodProdRemarksSum'
                      ? true
                      : column.overflowTooltip
                  "
                >
                  <!-- ADD 2025/04/02 ZLL 課題_250401顧客からの改善したい点への対応 start↓ -->
                  <!-- 課題_備考機能の追加 -->
                  <template #default="scope">
                    <template v-if="column.prop === 'aodProdRemarksSum'">
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                      <!-- 共通備考の調整 -->
                      <!-- <div class="button-container">
                        <t-tooltip placement="bottom" effect="light">
                          <div
                            slot="content"
                            class="tooltip-content"
                            v-html="
                              formatRemarksShowProc(scope.row.aodProdRemarksSum)
                            "
                          ></div>
                          <t-button
                            :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                            icon="el-icon-search"
                            size="small"
                            circle
                          >
                          </t-button>
                        </t-tooltip>
                      </div> -->
                      <div class="bikouDiv">
                        <!-- 備考表示 -->
                        <span class="bikouText">
                          {{ scope.row.aodProdRemarksSum }}
                        </span>
                      </div>
                      <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                    </template>

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                  <!-- ADD 2025/04/02 ZLL 課題_250401顧客からの改善したい点への対応 end↑ -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  formatRemarksShow,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
export default {
  data() {
    return {
      cc: [],
      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(window.innerHeight, 20, 0, 0),

      //合計情報のheight
      bottomHeight: 10 * 1,

      // 待つ
      loading: true,

      columns: [
        // NO.
        {
          prop: "indexNo",
          label: "NO.",
          realWidth: t("widgetSize.tableCommon.width50"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        {
          // 订单号
          prop: "crdOrderNoShow",
          label: "订单号",
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.checkReceInfo.crdProductName"),
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.checkReceInfo.crdPictureNo"),
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 異常区分
        {
          prop: "prodExKbn",
          label: t("resource.checkReceInfo.exceptionKbn"),
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 数量
        {
          prop: "crdReceQty",
          label: "数量",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // NG数
        {
          prop: "crdSizeCheckNgQty",
          label: "NG数",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // OK数
        {
          prop: "crdSizeCheckOkQty",
          label: "OK数",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // 備考
        // {
        //   prop: "crdRemarks",
        //   label: t("resource.checkReceInfo.crdBikou"),
        //   width: "180",
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },
        // 備考
        {
          label: t("resource.REMARKS_ADD.REMARKS"),
          class: "cell_txt_center",
          prop: "aodProdRemarksSum",
          min_width: 100,
          scopedSlots: {
            default: "aodProdRemarksSum",
          },
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 異常
        // {
        //   prop: "errMessage",
        //   label: "異常",
        //   realWidth: "180",
        //   width: "180",
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },
      ],

      //現在選択されているセル
      currentCell: [],
    };
  },

  props: {
    CheckReceByDeliceryDtos: {
      Type: Object,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    this.CheckReceByDeliceryDtos.forEach((item) => {
      this.cc.push(item);
    });

    // this.cc = { ...this.CheckReceByDeliceryDtos };

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 列幅に自動調整
    // setColumnWidth(this.columns, this.CheckReceByDeliceryDtos);
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // 初期化
    this.init();

    // 根据 errMessage 的长度动态添加列
    this.updateColumnsBasedOnErrMessage();

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 列幅に自動調整
    // setColumnWidth(this.columns, this.CheckReceByDeliceryDtos);
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
  },

  computed: {},

  methods: {
    // 初期化
    init() {
      this.loading = false;

      // this.cc = this.CheckReceByDeliceryDtos;
    },

    //确定ボタン
    confirmClick() {
      this.loading = true;

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.CheckReceByDeliceryDtos);
    },

    handleResize() {
      const dialogBody = document.querySelector(".el-dialog__body");

      if (dialogBody) {
        const height = dialogBody.offsetHeight;
        this.detailHeight = height - 50;
      } else {
        this.detailHeight = window.innerHeight * 0.7;
      }
    },

    updateColumnsBasedOnErrMessage() {
      const data = this.cc;
      if (data && data.length > 0) {
        // 找到最大的 errMessage 数量
        let maxErrMessageLength = 0;

        data.forEach((item) => {
          if (item.errMessage && item.errMessage.length > maxErrMessageLength) {
            maxErrMessageLength = item.errMessage.length;
          }
        });

        // console.log(maxErrMessageLength);

        // 创建对应的列
        for (let i = 0; i < maxErrMessageLength; i++) {
          this.$set(this.columns, this.columns.length, {
            prop: `errMessage${i}`,
            label: `異常 ${i + 1}`,
            width: "200",
            class: "cell_txt_left",
            overflowTooltip: false,
            columnValue: "1",
          });
        }

        // 为每条数据设置对应列的值
        data.forEach((item) => {
          if (item.errMessage) {
            item.errMessage.forEach((message, index) => {
              item[`errMessage${index}`] = message;
            });
          }
        });
      }
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.cc);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-form-item__label.custom-label {
  width: 20%;
}

.left-align {
  justify-content: left !important;
}
</style>
